export const INITIALIZE_CART = 'INITIALIZE_CART';
export const UPDATE_TOTALS = 'UPDATE_TOTALS';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const EMPTY_CART = 'EMPTY_CART';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
